<template>
  <div>
    <bottom-bar :home="id_theme === '1'"/>
    <div class="content">
      <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
      <div v-if="empresa.id_empresa" v-show="!load">
        <card-franquia class="d-md-none" :home="true" v-if="franquiasEnabled && id_theme === '1'"/>
        <download-app/>
        <div v-if="id_theme === '1'">
          <div class="carrossel-home" v-if="empresa.destaques && empresa.destaques.length">
            <carrosell-home :slides="empresa.destaques" :empresa="empresa"/>
          </div>
          <div class="container-capa" v-else>
            <imagem-carregavel prioridade="high" class="capa-empresa" :src="empresa.url_capa || img_default" :fallback="img_default" :alt="empresa.nome_fantasia" />
          </div>
          <company-header class="container-fluid mb-3" :empresa="empresa" :fallback="base_cdn + '/static/imgs/default.png'" truncate-name>
                <div class="d-flex align-items-center flex-wrap">
                  <span class="small"><icon name="address" size="15" full="true" class="fi-2"/> {{ empresa.nome_cidade | nome_cidade }} - {{ empresa.sigla_estado }}</span>
                  <i class="i-point mx-2"></i>
                  <router-link :to="url + `/info`" class="text-primary font-weight-bold text-nowrap small" data-nosnippet>Saiba mais</router-link>
                </div>
          </company-header>
          <div class="container-fluid mb-4">
            <div v-if="empresa.ativo === '1' && empresa.aberto === '1'">
              <a href="javascript:" v-if="sacola.origin === '4'" @click="clearSacola">
                <card-info title="Pedido No Local" class="mb-2" :icon="nolocal.onde_estou === 'Drive-thru' ? 'drive-thru' : 'qrcode'" icon-pos="fa-trash-o">
                  <div class="small">{{nolocal.onde_estou}}<span v-if="nolocal.obs_pedido">: {{nolocal.obs_pedido}}</span></div>
                </card-info>
              </a>
              <taxa-tempo ref="taxa" class="mb-2" v-else/>
            </div>
            <div v-else-if="empresa.empresaAberta">
              <card-info title="Agende seu pedido" class="mb-2" icon="agendar">
                <div class="small text-normal" v-if="empresa.proximo_horario">Abrimos {{ empresa.proximo_horario.label }} às {{ empresa.proximo_horario.horario_inicio }}</div>
                <div class="small text-normal" v-else>Escolha o melhor horário para receber</div>
              </card-info>
            </div>
            <div v-else>
              <card-info :title="empresa.aberto === '0' ? 'Estamos fechados' : 'Fechado no momento'" class="mb-2" icon="agendar">
                <div class="small text-normal" v-if="empresa.pausa_programada">{{empresa.pausa_programada}}</div>
                <div class="small text-normal" v-else-if="empresa.proximo_horario">Abrimos {{ empresa.proximo_horario.label }} às {{ empresa.proximo_horario.horario_inicio }}</div>
                <div class="small text-normal" v-else>Fique a vontade para ver nossos produtos!</div>
              </card-info>
            </div>
            <fidelidade componente="true" class="mb-4" v-if="empresa.fidelidade"/>
          </div>
          <div class="container-fluid">
            <div class="mb-4" v-if="cardapio.destaques.length > 0">
              <h3 class="h5 font-weight-bold mb-2">{{ tituloDestaque }}</h3>
              <carrosell :slides="cardapio.destaques"/>
            </div>
            <div class="mt-4">
              <h2 id="cardapio" class="font-weight-bold mb-2 h5">Cardápio</h2>
              <div class="form-control pointer d-flex justify-content-between align-items-center mb-2" @click="pesquisar()" style="height: 44px">
                <div>Buscar no cardápio</div>
                <icon name="search" size="15" class="text-primary" style="margin-top: -1px"/>
              </div>
              <cardapio class="mb-3" :categorias="cardapio.categorias" v-if="cardapio.categorias.length > 0"/>
            </div>
          </div>
        </div>
        <div class="container-fluid" v-else-if="id_theme === '2'">
          <div v-if="empresa.destaques && empresa.destaques.length">
            <carrosell-home :slides="empresa.destaques" :empresa="empresa"/>
          </div>
          <div class="mt-4">
            <label class="font-weight-bold mb-0">Buscar no cardápio</label>
            <div class="form-control pointer d-flex justify-content-between align-items-center" @click="pesquisar()" style="height: 44px">
              <div>O que você procura?</div>
              <icon name="search" size="15" class="text-primary" style="margin-top: -1px"/>
            </div>
          </div>
          <div class="mt-4 mb-3" v-if="cardapio.destaques.length > 0">
            <h3 class="h5 font-weight-bold mb-2">{{ tituloDestaque }}</h3>
            <carrosell :slides="cardapio.destaques"/>
          </div>
          <div v-for="c in cardapio.categorias">
            <div class="mb-4" v-if="c.produtos.length > 5">
              <div class="d-flex align-items-center mb-2">
                <h3 class="h5 font-weight-bold mb-0">{{ c.nome_categoria }}</h3>
                <router-link :to="`/categorias/?id=${c.id_categoria}`" class="text-primary font-weight-bold small" style="margin-left: 10px">Ver todos</router-link>
              </div>
              <carrosell :slides="c.produtos"/>
            </div>
          </div>
          <h2 class="font-weight-bold mt-4 h5">Categorias</h2>
          <cardapio class="mb-3" :categorias="cardapio.categorias" v-if="cardapio.categorias.length > 0" :icon="true"/>
        </div>
        <ads-le-card/>
      </div>
    </div>
  </div>
</template>

<script>
  import ImagemCarregavel from "../../../components/ImagemCarregavel";
  import BottomBar from '../../../components/BottomBar'
  import Loading from '../../../components/Loading'
  import Carrosell from '../../../components/Carrosell'
  import Cardapio from '../../../components/Cardapio'
  import CardInfo from '../../../components/CardInfo'
  import AdsLeCard from "../../../components/AdsLeCard";
  import RedesSociais from "../../../components/RedesSociais";
  import DownloadApp from "../../../components/DownloadApp";
  import CardFranquia from "../../../components/CardFranquia";
  import ModalPromo from "../../../components/Modal";
  import CompanyHeader from "../../../components/CompanyHeader";
  import Icon from "../../../components/Icon";
  import TaxaTempo from "../../../components/TaxaTempo";
  import CardsHome from "../components/CardsHome";
  import CarrosellHome from "../components/CarrosellHome";
  import Fidelidade from "../../../pages/Fidelidade";
  import Categorias from '../../../pages/Categorias'
  import store from "../store";

  export default {
    name: 'HomeApp',
    components: {CompanyHeader, ImagemCarregavel,
      Categorias,
      Fidelidade,
      TaxaTempo,
      CarrosellHome,
      CardsHome,
      Cardapio,
      Icon,
      ModalPromo, CardFranquia, DownloadApp, AdsLeCard, RedesSociais, BottomBar, Loading, Carrosell, CardInfo
    },
    data() {
      return {
        load: false,
        token: localStorage.getItem('token'),
        destaques: [],
        url: ''
      }
    },

    methods: {
      loadDados() {
        this.load = false;

        if (this.$route.query.sacola === 'true') {
          this.$emit('openSacola');
        }
      },

      clearSacola() {
        this.$swal({
          text: 'Deseja realmente cancelar seu pedido no local?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.load = true;
            this.$store.state.nolocal = { obs_pedido: '', onde_estou: '' };
            this.$store.state.sacola.tipo_pedido = '';
            this.$store.state.sacola.nolocal = null;
            this.$store.state.sacola.origin = this.origin;
            localStorage.setItem('sacola', JSON.stringify(this.$store.state.sacola));
            localStorage.removeItem('nolocal');

            this.$helpers.getCardapioEmpresa(this, this.empresa.token, null, (res) => {
              if (res) {
                this.$swal('Pedido no local cancelado com sucesso!');
                this.load = false;
              }
            });
          }
        });
      },

      pesquisar() {
        const target = this.url + '/categorias?search=true';

        if (this.$route.fullPath !== target) {
          this.$router.push(target);
        }
      },

      messageEntrega() {
        this.$swal("Valor variável baseado na distância do endereço de entrega.");
      }
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
      this.loadDados();
    },

    created() {
      document.body.classList.remove("modal-open");
    },

    beforeRouteLeave(to, from, next) {
      if (this.$refs.taxa && this.$refs.taxa.opened) {
        this.$refs.taxa.closeModal();

      } else {
        next()
      }
    },

    computed: {
      sacola() {
        return this.$store.state.sacola
      },

      nolocal() {
        return this.$store.state.nolocal
      },

      empresa() {
        return this.$store.state.empresa
      },

      usuario() {
        return this.$store.state.dataUser
      },

      cardapio() {
        return this.$store.state.cardapio
      },

      tituloDestaque() {
        const titulo = this.empresa?.json_config?.titulo_destaque;
        return titulo ? titulo : 'Destaques';
      },

      id_theme() {
        return this.$store.state.empresa.id_theme
      }
    },

    filters: {
      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      },

      nome_cidade(nome) {
        if (nome.length > 17) {
          const ignorar = ["de", "da", "do", "das", "dos", "e"];
          const partes = nome.split(" ");
          return partes
              .map((palavra, index) => {
                // mantém a última palavra inteira
                if (index === partes.length - 1) {
                  return palavra.charAt(0).toUpperCase() + palavra.slice(1);
                }

                // ignora preposições/artigos
                if (ignorar.includes(palavra.toLowerCase())) {
                  return null;
                }

                return palavra.charAt(0).toUpperCase() + ".";
              }).filter(Boolean).join(" ");
        }

        return nome;
      }
    }
  }
</script>
<style scoped>
  .fixed-top + .content {
    padding-top: 110px;
  }

  .container-capa {
    position: relative;
    height: 200px;
    z-index: 1;
  }

  .capa-empresa {
    display: block;
    width: 100%;
    object-fit: cover;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: var(--lecard-primary)!important;
    border-radius: 0 0 18px 18px;
  }

  @media (min-width: 768px) {
    .container-capa {
      height: 280px;
      margin: 0 15px;
    }

    .carrossel-home {
      margin: 0 15px;
    }

    .capa-empresa {
      border: 3px solid #ffffff;
      border-radius: 18px;
    }

  }
</style>
